import Api from "./Api";

const endpoint = "/auth";
export default {
    get() {
        return Api.fetchData(endpoint);
    }
};
